<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <BreadCrumd
          :title="'Checklists'"
          :description="'Aperçu d\'une checklist'"
        />
      </div>
    </div>

    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row d-flex justify-content-lg-center">
                <div class="col-md-6 col-lg-4">
                  <div class="form-group">
                    <label for="nom"
                      >Nom checklist <span class="text-danger">*</span></label
                    >
                    <input
                      class="form-control"
                      id="nom"
                      v-model="form.nom"
                      type="text"
                      placeholder="Nom checklist"
                      maxlength="100"
                      disabled
                    />
                  </div>
                </div>

                <div class="col-md-2 col-lg-1 mt-3 pt-1">
                  <switches
                    text-enabled="Statut actif"
                    text-disabled="Statut inactif"
                    :value="form.statut"
                    type-bold="true"
                    color="custom-primary"
                    class="ml-1 mb-0 font-size-17"
                  ></switches>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-n4">
        <div class="col-md-12">
          <table class="card table table-sm">
            <thead>
              <tr class="d-flex">
                <th class="col-8">Libellé de la question</th>
                <th class="col-4 text-center">Statut</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in form.item_lists"
                :key="index"
                class="d-flex"
              >
                <td class="col-8" style="vertical-align: middle">
                  <input
                    class="form-control"
                    v-model="item.libelle"
                    type="text"
                    placeholder="Libellé de la question"
                    disabled
                  />
                </td>

                <td class="col-4 text-center" style="vertical-align: middle">
                  <toggle-button
                    :width="width"
                    :height="height"
                    :font-size="font"
                    v-model="item.statut"
                    :labels="{ checked: 'Actif', unchecked: 'Inactif' }"
                    :color="{
                      checked: '#5CB85C',
                      unchecked: 'red',
                    }"
                    disabled
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row mb-4 mt-2">
        <div class="col-md-12 text-right">
          <button
            type="button"
            class="btn btn-secondary mr-4"
            @click.prevent="
              $router.push({ name: 'gpao_checklist' }).catch(() => {})
            "
          >
            Liste des checklists
          </button>

          <button
            type="button"
            class="btn btn-custom-primary"
            style="min-width: 100px"
            @click.prevent="
              $router
                .push({ name: 'gpao_checklist-edit', params: { id: id } })
                .catch(() => {})
            "
          >
            Modifier
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/http/gpao/checklist';
export default {
  data() {
    return {
      form: {
        nom: '',
        statut: false,
        item_lists: [],
      },
      width: 85,
      height: 30,
      font: 13,
      title: 'Gestion des checklists - Aperçu',
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    init() {
      this.id = this.$route.params.id;

      window.axios
        .get(URL.CHECKLIST + '/' + this.id)
        .then((resp) => {
          this.form = Object.assign({}, resp.data.checklist);
        })
        .catch();
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
